import {baseKeysUseQuery} from '#/hooks/query/base/base-keys-use-query';
import {useQueryClient} from '@tanstack/react-query';
import {Hex} from 'viem';

export const useInvalidateQueries = () => {
  const queryClient = useQueryClient();

  return {
    useLands: () => {
      const queryKey = [baseKeysUseQuery.useLands];
      queryClient.invalidateQueries({queryKey});
    },
    useLandMarketInfos: (landId: number) => {
      const queryKey = [baseKeysUseQuery.useLandMarketInfo, landId];
      queryClient.invalidateQueries({queryKey});
    },
    useLandAccountInfos: (account: Hex | undefined, landId: number) => {
      const queryKey = [baseKeysUseQuery.useLandAccountInfo, account, landId];
      queryClient.invalidateQueries({queryKey});
    },
    useStableTokenBalance: () => {
      const queryKey = [baseKeysUseQuery.useStableTokenBalance];
      queryClient.invalidateQueries({queryKey});
    },
    useNativeTokenBalance: () => {
      const queryKey = [baseKeysUseQuery.useNativeTokenBalance];
      queryClient.invalidateQueries({queryKey});
    },
    useLimitOrdersIds: (landId: number) => {
      const queryKey = [baseKeysUseQuery.useLimitOrdersIds, landId];
      queryClient.invalidateQueries({queryKey});
    },
    useLimitOrders: (landId: number) => {
      const queryKey = [baseKeysUseQuery.useLimitOrders, landId];
      queryClient.invalidateQueries({queryKey});
    },
    useUserProfile: (account: string) => {
      const queryKey = [baseKeysUseQuery.useUserProfile, account];
      queryClient.invalidateQueries({queryKey});
    },
    useUserProfilePrivate: (account: string) => {
      const queryKey = [baseKeysUseQuery.useUserProfilePrivate, account];
      queryClient.invalidateQueries({queryKey});
    },
    useFundingStatus: () => {
      const queryKey = [baseKeysUseQuery.useFundingStatus];
      queryClient.invalidateQueries({queryKey});
    },
    usePortfolioLandAssets: (account: Hex | undefined) => {
      const queryKey = [baseKeysUseQuery.usePortfolioLandAssets, account];
      queryClient.invalidateQueries({queryKey});
    },
  };
};
